// extracted by mini-css-extract-plugin
export default {"editButton":"onetimeDeduction_editButton__W0q19","TableBody":"onetimeDeduction_TableBody__ykBjx","deleteButton":"onetimeDeduction_deleteButton__ZHK2y"};